import React from "react"; 
import AffiliateDoc from '../assets/affiliateprogramagreement.docx';
import Services from '../assets/spurtree-services.pdf';



function MainContent(){
    return(
        <div className="innerContent">
            <div className="container">
                <article>
                    <h2>New Revenue Model</h2>
                    <p>SpurTree Technologies, (STT) wishes to provide meaningful incentives for the expanded network of interested partners.  The commission model is intended to expand the network of prospects while maintaining the strong brand of SpurTree Technologies. SpurTree pays you monthly based on the previous month’s activity.</p>
                </article>

                <article>
                    <h2>Business Development and Sales Generation </h2>
                    <p><span className="subPara">This commission model supports introductions to SpurTree Technologies for qualified leads.</span>
                    <span className="subPara">Qualified leads are defined as a new logo organization that has a stated interest in one or more of the <a href={Services}>service offerings</a> or products from STT and has budget for the desired services. The partner  is defined as the Affiliate Partner who will understand the service offerings of SpurTree Technologies and understand the value proposition. This partner can leverage SpurTree’s account executives and technical pre-sales team for engagements as needed.  Based on this model, the partner is not expected to have overall Account Management duties but will serve as the referral liaison for the initial deal and will be involved in the sales activities if required. </span>
                        Total Contract Value (TCV) is the USD value of the engagement for the first 12 months. </p>
                </article>

                <article>
                    <h2>Commission Model <span className="currency">(Currency is USD)</span></h2>
                    <p> <span className="subPara">For deals that result in a <strong>TCV of $20,000 </strong>or less, the commission will be <strong>5%</strong> of the total value.</span>
                        For deals exceeding <strong>$20,000 TCV</strong>, the commission will be structured as follows:
                        <ul>
                            <li>
                                <strong> 5%</strong> on the first<strong> $20,000</strong>
                            </li>
                            <li>
                            <strong>8%</strong> on any amount above <strong>$20,000</strong>
                            </li>
                        </ul>
                    </p>
                    <p> As an example, a partner may refer an opportunity for two backend software developers for a Client.   This one-year deal is for one nearshore resource and one offshore resource.
                    </p>
                </article>

                <article>
                    <h2></h2>
                    <p></p>
                </article>
                <div className="table-responsive">
                    <table className="table table-striped pricing">
                        <thead>
                        <tr>
                            <th>Resource</th>
                            <th>Rate per hour</th>
                            <th>Total per month</th>
                            <th>Total per year</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Near Shore Dev</td>
                            <td>$75</td>
                            <td>$12,000</td>
                            <td>$144,000</td>
                        </tr>
                        <tr>
                            <td>India Team Dev</td>
                            <td>$50</td>
                            <td>$8,000</td>
                            <td>$96,000</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td className="total">Total</td>
                            <td className="total">$240,000</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td className="td-small">1st 20k Commission</td>
                            <td className="td-green">$1000</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td className="td-small">Remaining Commission</td>
                            <td className="td-green">$17,600</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td className="td-small">Total 1 year Commission</td>
                            <td className="td-green">$18,600</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p className="agreement">Feel free to download and review the affiliate <a href={AffiliateDoc}>partner agreement</a> </p>
            </div>
        </div>
    )
}

export default MainContent;